module.exports = __webpack_public_path__ + "static/108_home-f4a9bec62741e7ef13dbf84600d14e29.png";